var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockEmbedded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.875C7.23915 14.875 6.0066 14.5011 4.95824 13.8006C3.90988 13.1001 3.09278 12.1045 2.61027 10.9396C2.12776 9.77473 2.00152 8.49293 2.2475 7.2563C2.49348 6.01967 3.10064 4.88376 3.9922 3.9922C4.88376 3.10064 6.01967 2.49348 7.2563 2.2475C8.49293 2.00152 9.77473 2.12776 10.9396 2.61027C12.1045 3.09278 13.1001 3.90988 13.8006 4.95824C14.5011 6.0066 14.875 7.23915 14.875 8.5C14.8732 10.1902 14.2009 11.8106 13.0058 13.0058C11.8106 14.2009 10.1902 14.8732 8.5 14.875ZM8.5 3.1875C7.44929 3.1875 6.42217 3.49908 5.54854 4.08282C4.6749 4.66656 3.99398 5.49626 3.59189 6.467C3.1898 7.43773 3.0846 8.50589 3.28958 9.53642C3.49456 10.5669 4.00053 11.5135 4.7435 12.2565C5.48646 12.9995 6.43306 13.5054 7.46358 13.7104C8.49411 13.9154 9.56227 13.8102 10.533 13.4081C11.5037 13.006 12.3334 12.3251 12.9172 11.4515C13.5009 10.5778 13.8125 9.55071 13.8125 8.5C13.811 7.09151 13.2507 5.74116 12.2548 4.74521C11.2588 3.74925 9.90849 3.18905 8.5 3.1875Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34686 10.4114L5.7832 9.51044L7.96877 8.14141V5.3125H9.03126V8.73003L6.34686 10.4114Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockEmbedded);
export default __webpack_public_path__ + "static/media/clock-embedded.34a1449d31f4592fefdfbf31ef798a07.svg";
export { ForwardRef as ReactComponent };